$(document).ready(function() {  

  // Mobile Slideout Navigation  
  $.shifter({
    maxWidth: "740px"
  });   


  // Mobile Navigation Toggles


  $(".mobile-nav__toggle-open").click(function(e) {
    $(this).toggleClass('opened');
    $(this).siblings("ul").stop().slideToggle();
    e.preventDefault();
  });


  // MatchHeight

  $('.recipient-block').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
  });

  $('.product-index').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
  });

  // Quantity values
  $('.up').click(function(e){
    e.preventDefault();
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[name='+fieldName+']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(1);
    }
  });
  $(".downer").click(function(e) {
    e.preventDefault();
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[name='+fieldName+']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 1) {
      // Decrement one
      $('input[name='+fieldName+']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[name='+fieldName+']').val(1);
    }
  }); 

  if ( $(this).width() > 740 ) {
    $('.product-index-inner').hover(function(){ $(this).children('.product-modal').show(); }, function(){ $(this).children('.product-modal').hide(); })
    // Flipping Images
    $('.product-index-inner').each(function(){
      if($(this).find('img').length > 1) {
        $(this).find('.img2').hide().css('display', 'none');
        $(this).hover(function(){
          $(this).find('.img2').stop(true,true).fadeIn("3000");
          $(this).find('.img1').stop(true,true).fadeOut("3000").css("display", "none");
        }, function(){
          $(this).find('.img2').stop(true,true).fadeOut("3000").css("display", "none");
          $(this).find('.img1').stop(true,true).fadeIn("3000");
        });
      }
    });  
  }

  // Help old browsers with placeholders for inputs 
  $('input, textarea').placeholder();


  // Call Flexslider globally
  $('#flexslider').flexslider({
    animation: "fade",
    controlNav: false,
    slideshowSpeed: 6000,
    directionNav: true
  });  



  $(window).load(function(){

      //set some variables for calculating the hash

      var index = 0, hash = window.location.hash;

      //via malsup (Cycle plugin), calculates the hash value

      if (hash) {
          index = /\d+/.exec(hash)[0];
          index = (parseInt(index) || 1) - 1;
      }

      $("#lookbook").flexslider({
          animation: "fade",
          //controlNav: "thumbnails",
          controlNav: false,
          slideshow: false,
          directionNav: true,
          smoothHeight: true,
          start: function(slider) {
            slider.removeClass('loading');
          },
          startAt: index, //now foo.html#3 will load item 3
          after:function(slider){
              window.location.hash = slider.currentSlide+1;
              //now when you navigate, your location updates in the URL
          }
        
      })
  })


  // Custom select dropdowns  
  $('.styled-select').selecter();  
  $('.coll-picker').selecter();  
  $('.coll-filter').selecter();  
  

  // Call Fancybox for product modal + stop scroll to top 
  $('.product-modal').fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });


  // Call Fancybox globally on all elements with class fancybox
  $(".fancybox").fancybox({
    helpers: {
      overlay: {
        locked: false
      }
    }
  });  

});

// $(function () {
//   $(window).on("resize", function () {

//     //offsetDescription();

//     // dropdown + secondary mobile/desktop switch

//     $('.navigation .nav li').hover(function(){

//         if($(window).width() > 740) {
//           $(this).addClass('open');
//         }
//       },

//     function(){

//       if($(window).width() > 740) {
//         $(this).removeClass('open');
//       }

//     });

//   }).resize();

// });



